import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { GeneralIcons } from '@bluebeam/react-skyline-art';
import { ListboxItem } from '@bluebeam/react-skyline-listbox';
import { useObjectRef } from '@react-aria/utils';
import { forwardRef } from 'react';
import { useOption } from 'react-aria';
const DropdownListboxOption = forwardRef(({ children, state, value, ...rest }, ref) => {
    const optionRef = useObjectRef(ref);
    const { optionProps: { ...optionProps }, } = useOption({ ...rest, key: value }, state, optionRef);
    return (_jsxs(ListboxItem, { className: "flex flex-row justify-between gap-x-2", ref: optionRef, ...optionProps, children: [_jsx("div", { className: "flex-grow truncate", children: children }), state.selectionManager.isSelected(value) && (_jsx("span", { className: "pointer-events-none", children: _jsx(GeneralIcons.CheckIcon, { size: "24px", className: "text-primary-blue" }) }))] }));
});
export default DropdownListboxOption;
//# sourceMappingURL=DropdownListboxOption.js.map